import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ArticleCtaProps {
  lang: string;
}

export default function ArticleCta({ lang }: ArticleCtaProps) {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-primary-50">
      <div className="w-full max-w-4xl mx-auto rounded-lg bg-background-50 border border-primary-100 p-8 md:p-12 text-center">
        <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-book-open-line text-2xl"></i>
        </span>
        <h2 className="mt-5 text-2xl md:text-3xl font-heading font-bold">
          {t("articleCta.title")}
        </h2>
        <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
          {t("articleCta.subtitle")}
        </p>
        <Link
          to={`/${lang}/guide`}
          className="mt-7 inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {t("articleCta.button")}
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}